import React from 'react';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router';
import CBMediaQuery from '../shared/CBMediaQuery';
import { getStyle, formatDate, styleMerge } from '../../utils/utils';
import CBLabelAndCheckbox from '../shared/CBLabelAndCheckbox';
import VehicleListTd from '../OrganizationGarageView/OrganizationGarageComponents/VehicleListTd';

class ManufacturerServiceBookHistoryListItem extends React.Component {ManufacturerServiceBookHistoryListItem
  navigateToMaintenance = () => {
    const { history, entry } = this.props;
    const vehicleId = entry.vehicle.id;
    const maintenanceId = entry.maintenance_id;
    history.push(`/vehicle/${vehicleId}/maintenances/${maintenanceId}`);
  };

  navigateToVehicle = () => {
    const { history, entry } = this.props;
    const vehicleId = entry.vehicle.id;
    history.push(`/vehicle/${vehicleId}`);
  };

  navigateToOe = () => {
    const { entry } = this.props;
    window.open(entry.url, '_blank');
  };

  getStatusColor = (status) => {
    switch (status) {
      case 100:
        return '#4CAF50';  // Green
      case 900:
        return '#F44336';  // Red
      case 200:
        return '#FFC107';  // Yellow
      case 700:
        return '#2196F3';  // Blue
      default:
        return '#666666';  // Grey
    }
  };

  checkBoxChanged = () => {
    const {
      selected,
      select,
      unselect,
      entry,
    } = this.props;

    if (selected) {
      unselect(entry.id);
    } else {
      select(entry.id);
    }
  };

  render() {
    const { entry, t, selectedFields, selected } = this.props;
    const vehicle = entry.vehicle;

    return (
      <CBMediaQuery>
        {screenSize => (
          <tr style={getStyle(screenSize, styles, 'row')}>
            {
              false && (
                <td style={getStyle(screenSize, styles, 'tableRegNumTd')}>
                  <CBLabelAndCheckbox
                    additionalStyles={{ justifyContent: 'center' }}
                    checked={selected}
                    onChange={this.checkBoxChanged}
                  />
                </td>
              )
            }

            {selectedFields.includes('vehicle') && (
              <VehicleListTd
                onClick={this.navigateToVehicle}
                textPrimary={vehicle.registration_number}
                textSecondary={[vehicle.manufacturer, vehicle.model_name].filter(Boolean).join(' ')}
                additionalStylesPrimaryText={{ fontSize: 24 }}
              />
            )}

            {selectedFields.includes('status') && (
              <VehicleListTd
                onClick={this.navigateToOe}
                textPrimary={
                  <div style={{
                    ...getStyle(screenSize, styles, 'statusBadge'),
                    backgroundColor: this.getStatusColor(entry.external_status)
                  }}>
                    {entry.external_status_display}
                  </div>
                }
              />
            )}

            {selectedFields.includes('external_status') && (
              <VehicleListTd
                onClick={this.navigateToOe}
                textPrimary={entry.external_status_display ? entry.external_status_display : '-'}
                textSecondary={entry.external_status_reason_display ? entry.external_status_reason_display : null}
              />
            )}

            {selectedFields.includes('created_at') && (
              <VehicleListTd
                onClick={this.navigateToOe}
                textPrimary={formatDate(entry.created_at)}
              />
            )}

            <td onClick={(e) => {e.stopPropagation(); window.open(entry.document_url, '_blank')}} style={styleMerge(getStyle(screenSize, styles, 'tableValueTd'), getStyle(screenSize, styles, 'alignCenter'))}>
                    {
                      entry.external_status == 700 && entry.document_url && (
                            <img
                              className='opacity-on-hover'
                              src='/img/icon_vehicle_report.svg'
                              alt='Hae raportti'
                              style={getStyle(screenSize, styles, 'infoIcon')}
                            />
                          )
                    }
                  </td>

          </tr>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {

    row: {
      height: '60px',
      width: '100%',
      marginBottom: 2,
      cursor: 'pointer',
      ':hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)'
      }
    },
    tableRegNumTd: {
      fontFamily: 'TitilliumWeb-Bold',
      fontSize: 18,
      color: '#FFFFFF',
      left: 0,
      padding: '8px 16px 8px 16px',
      borderBottom: '1px solid rgba(255, 255, 255, .3)',
    },
    statusBadge: {
      display: 'inline-block',
      padding: '4px 8px',
      borderRadius: 4,
      fontSize: 14,
      fontWeight: 'bold'
    },
    infoIcon: {
        height: 32,
        width: 32,
    },
    alignCenter: {
        textAlign: 'center',
    },
    tableValueTd: {
      fontFamily: 'TitilliumWeb-Light',
      fontSize: 18,
      color: '#FFFFFF',
      padding: 8,
      cursor: 'pointer',
      borderBottom: '1px solid rgba(255, 255, 255, .3)',
    },
  },
  medium: {},
  small: {}
};

export default translate('ManufacturerServiceBook')(withRouter(ManufacturerServiceBookHistoryListItem));